import React from 'react';
export function SnakkerLogo({
  className = ''
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/4fWe7e5i1gSJ9sF42PLdTJ/snakker_logo_new2.png" alt="Snakker" className={`h-7 w-auto object-contain ${className}`} data-id="element-115" />;
}